import type { TrpcClient } from "../trpc";
import type { Member } from "@satyrsmc/shared/dto/admin/member";

export type CreateMemberBody = {
  name: string;
  phone_number?: string;
  email?: string;
  address?: string;
  birthday?: string;
  is_baby?: boolean;
  emergency_contact_name?: string;
  emergency_contact_phone?: string;
  photo?: string;
};

export class MembersApiClient {
  constructor(private client: TrpcClient) {}

  list(): Promise<Member[]> {
    return this.client.admin.members.list.query();
  }

  get(id: string): Promise<Member> {
    return this.client.admin.members.get.query({ id });
  }

  create(body: CreateMemberBody) {
    return this.client.admin.members.create.mutate(body as never);
  }

  update(id: string, body: Record<string, unknown>) {
    return this.client.admin.members.update.mutate({ id, ...body } as never);
  }

  delete(id: string) {
    return this.client.admin.members.delete.mutate({ id });
  }
}
